import { useEffect, useState } from "react";
import axios from "axios";

/**
 * Small footer badge that lets the user quickly see which environment
 * (Preview vs Production) the private app is currently connected to,
 * and how many of their own records exist in this database. Renders
 * only inside the authenticated Layout, so it never leaks to fans.
 */
export function EnvBadge() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
    const token = localStorage.getItem("lxn_token");
    axios.get(`${API}/env/counts`, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then(({ data }) => setInfo(data))
      .catch(() => {});
  }, []);
  if (!info) return null;
  const total = Object.values(info.counts || {}).reduce((a, b) => a + b, 0);
  const isPreview = /preview/i.test(window.location.hostname);
  return (
    <div className="fixed bottom-3 left-3 z-30 hidden md:flex items-center gap-2 text-[10px] text-zinc-500 bg-black/70 backdrop-blur border border-white/5 rounded-full px-3 py-1"
      data-testid="env-badge" title={`DB: ${info.db_name} · Workspace records: ${total}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${isPreview ? "bg-amber-400" : "bg-emerald-400"}`} />
      <span className="uppercase tracking-widest">{isPreview ? "Preview" : "Prod"}</span>
      <span className="mono">· {total} records</span>
    </div>
  );
}
